import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import LoginEmailContainer from 'src/app/containers/Login/LoginFormEmailContainer';
import LoginPasswordContainer from 'src/app/containers/Login/LoginFormPasswordContainer';
import LoginFormButtonsContainer from 'src/app/containers/Login/LoginFormButtonsContainer';
import { loginEmailSetValidationMessage, loginEmailSetVisualization } from 'src/app/redux/actions/login/loginEmail';
import {
  loginPasswordSetvalidationMessage,
  loginPasswordSetVisualization
} from 'src/app/redux/actions/login/loginPassword';
import { loginFormSend } from 'src/app/redux/actions/login/login';
import 'src/app/containers/Login/LoginFormContainer.scss';


class LoginFormContainer extends React.Component {

  passwordInputRef = React.createRef();

  emailInputRef = React.createRef();

  submit = (event) => {
    event.preventDefault();

    const form = event.target;
    const { dispatch, email, password } = this.props;

    if (!form.checkValidity()) {
      form.scrollIntoView();
      this.dispatchErrorVisualization();
      return;
    }

    dispatch(loginFormSend(email, password));
  };

  dispatchErrorVisualization = () => {
    const { emailInputRef, passwordInputRef } = this;
    const { dispatch } = this.props;

    dispatch(loginEmailSetValidationMessage(emailInputRef.current.validationMessage));
    dispatch(loginEmailSetVisualization(true));
    dispatch(loginPasswordSetvalidationMessage(passwordInputRef.current.validationMessage));
    dispatch(loginPasswordSetVisualization(true));
  };

  render() {
    const { customClass } = this.props;
    const { submit, emailInputRef, passwordInputRef } = this;

    return (
      <form onSubmit={ submit } noValidate className={ customClass }>
        <h4 styleName="form__title">
          Zaloguj się
        </h4>

        <div styleName="form__input">
          <LoginEmailContainer inputRef={ emailInputRef }/>
        </div>

        <div styleName="form__input">
          <LoginPasswordContainer inputRef={ passwordInputRef }/>
        </div>

        <LoginFormButtonsContainer/>
      </form>
    );
  }
}

LoginFormContainer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  customClass: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  password: PropTypes.string.isRequired
};

const mapStateToProps = state => ({
  email: state.loginEmailReducer.value,
  password: state.loginPasswordReducer.value
});

export default connect(mapStateToProps)(LoginFormContainer);
